import { RegionFormSchema } from "../../schemas/forms";
import { regions } from "../../api/regions.service";
import type { Region } from "../../api/regions.service";
import type { HierarchyManagerConfig } from "../../components/HierarchyManager";
import type { ZodType } from "zod";

export const regionConfig: HierarchyManagerConfig<Region> = {
  // Display configuration
  title: "Regions",
  singularName: "Region",
  pluralName: "Regions",

  // API service
  apiService: regions,

  // Form fields configuration (camelCase to match UI/validation)
  formFields: [
    {
      name: "parentId",
      label: "Parent Region",
      type: "select",
      required: false,
      searchable: true,
      defaultValue: null,
    },
    {
      name: "name",
      label: "Name",
      type: "text",
      required: true,
      placeholder: "Enter region name",
      defaultValue: "",
    },
    {
      name: "code",
      label: "Code",
      type: "text",
      required: true,
      placeholder: "Enter region code (e.g., EMEA, APAC)",
      defaultValue: "",
    },
    {
      name: "displayOrder",
      label: "Display Order",
      type: "number",
      required: false,
      defaultValue: 0,
      helperText: "Lower numbers appear first",
    },
  ],

  // Validation schema from shared package (camelCase)
  validationSchema: RegionFormSchema,

  // Feature flags
  enableDragAndDrop: true,
  enableSearch: true,
  enableBreadcrumbs: true,
  showCode: true,
};
